import { Select, Switch } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { SettingRow, SettingRowSelect } from "@/components/elements/Settings";
import { CurrencyCode, currencyMap, defaultCurrency } from "@/lib/currency";
import { useUpdateUserSettings } from "@/services/profile/update-user-settings";

import type { Currency } from "@/types/currency";

const CurrencyHandler = () => {
  const { t } = useTranslation();

  const [currency, setCurrency] = useLocalStorage<Currency>({
    key: "currency",
    defaultValue: defaultCurrency,
  });
  const updateSettings = useUpdateUserSettings();

  const handleSelectCurrency = (code: string) => {
    const selected = currencyMap[code] ?? currencyMap[CurrencyCode.EUR];
    setCurrency(selected);
    updateSettings.mutate({ currency: { code: selected.code } });
  };

  return (
    <>
      {Object.keys(currencyMap).length === 2 ? (
        <SettingRow
          label={t("common.currency")}
          leftSection={t("common.euro")}
          rightSection={t("common.dollar")}
        >
          <Switch
            onChange={(event) =>
              handleSelectCurrency(
                event.currentTarget.checked ? CurrencyCode.USD : CurrencyCode.EUR
              )
            }
            checked={currency.code === CurrencyCode.USD}
          />
        </SettingRow>
      ) : (
        <SettingRowSelect label={t("common.currency")}>
          <Select
            w={125}
            data={Object.values(currencyMap).map((c) => ({
              value: c.code,
              label: `${c.symbol} - ${c.code}`,
            }))}
            value={currency.code}
            onChange={(value) => {
              if (value) handleSelectCurrency(value);
            }}
          />
        </SettingRowSelect>
      )}
    </>
  );
};

export default CurrencyHandler;
